export const NoiOSAlert = () => {
    const alertStyle = {
        backgroundColor: "#ffffff",
        borderRadius: "0px",
        padding: "16px",
        boxShadow: "4px 4px 4px 4px rgba(0,0,0,0.2)",
        color: "#000000",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        maxWidth: "800px"
    } as const;

    const iconStyle = {
        width: "24px",
        height: "24px",
        flexShrink: 0
    } as const;

    const titleStyle = {
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        fontSize: "14px",
        margin: 0
    } as const;

    const bodyStyle = {
        fontSize: "14px",
        marginTop: "4px",
        marginBottom: "4px"
    } as const;

    return (
        <div style={alertStyle} role="alert">
            {/* icon */}
            <svg
                style={iconStyle}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                xmlns="http://w3.org"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
            </svg>

            {/* content */}
            <div>
                <p style={titleStyle}>IMPORTANT HOST NOTICE: PLEASE USE A LAPTOP OR DESKTOP COMPUTER</p>
                <p style={bodyStyle}>
                    For the best live show experience, please host your Jams using a Laptop or Desktop Computer.
                </p>
                <p style={bodyStyle}>
                    Due to browser audio limitations in our legacy v7 engine, hosting directly from an iPhone or iPad
                    (iOS) is not supported at this time. Running a show from an iOS device can cause audio playback
                    drops and session freezes.
                </p>
                <p style={bodyStyle}>🖥️ Supported Host Setup: Mac, Windows PC, or Chromebook.</p>
                <p style={bodyStyle}>📱 Supported Player Setup: Any computer, smartphone or tablet (iOS & Android)!</p>
                <p style={bodyStyle}>
                    <em style={{fontStyle: "italic"}}>
                        We are rebuilding our mobile host experience from the ground up in Jindo v9! Thank you for
                        protecting your stage by hosting on a computer
                    </em>
                </p>
            </div>
        </div>
    );
};

export default NoiOSAlert;
